import { lazy } from 'react';
import { SHOULD_AUTH, NO_DIFFERENT } from './enums';

const routes = [
  {
    title: 'بیمه با ما : خرید بیمه آنلاین، مقایسه قیمت بیمه خودرو',
    path: '/',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/home')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'بیمه با ما : تمدید بیمه آنلاین، مقایسه قیمت بیمه خودرو',
    path: '/tamdide-bime',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/tamdide-bime')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'شرکت بیمه',
    path: '/company/:id',
    exact: true,
    noindex: true,
    icon: '',
    component: () => lazy(() => import('pages/company')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'ورود کاربر',
    path: '/login',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/login')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'مقایسه و خرید بیمه',
    path: '/third-party/compare',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/third-party/compare')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'مقایسه و خرید بیمه',
    path: '/building/compare',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/building/compare')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'بیمه بدنه',
    path: '/car-insurance/compare',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/body')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'مقایسه و خرید بیمه',
    path: '/doctor/compare',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/doctor/compare')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'مقایسه و خرید بیمه',
    path: '/trip/compare',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/trip/compare')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'مقایسه و خرید بیمه',
    path: '/cure/compare',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/cure/compare')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  //hard code page
  {
    title: 'بیمه شخص ثالث',
    path: '/insurance/third-party',
    noindex: true,
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/hard-code/third-party')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'بیمه موتور',
    path: '/insurance/motor',
    noindex: true,
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/hard-code/motor')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'بیمه بدنه',
    path: '/insurance/body-insurance',
    noindex: true,
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/hard-code/ins-body')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'بیمه مسافرتی',
    path: '/insurance/travel-insurance',
    noindex: true,
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/hard-code/travel')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'بیمه عمر',
    path: '/insurance/life-insurance',
    noindex: true,
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/hard-code/life')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'بیمه انفرادی',
    path: '/insurance/single-insurance',
    noindex: true,
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/hard-code/single')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'بیمه درمانی',
    path: '/insurance/therapeutic-insurance',
    noindex: true,
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/hard-code/therapeutic')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'بیمه آتش سوزی',
    path: '/insurance/fire-insurance',
    noindex: true,
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/hard-code/fire')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'بیمه زلزله',
    path: '/insurance/earthquake-insurance',
    noindex: true,
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/hard-code/earthquake')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'بیمه مسئولیت پزشکان',
    path: '/insurance/physicians-insurance',
    noindex: true,
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/hard-code/physicians')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'سوالات متداول بیمه شخص ثالث',
    path: '/insurance/third-party-faq',
    noindex: true,
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/hard-code/third-party-faq')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'سوالات متداول بیمه بدنه',
    path: '/insurance/body-faq',
    noindex: true,
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/hard-code/body-faq')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'پشتیبانی و مشاوره آنلاین',
    path: '/advice',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/hard-code/advice')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'درباره ما',
    path: '/about-us',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/hard-code/about')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'تماس با ما',
    path: '/contact-us',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/hard-code/contact')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'قوانین و مقررات',
    path: '/terms-and-conditions',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/hard-code/policy')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'شرایط پرداخت قسطی',
    path: '/third-party/info',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/complate-profile')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'شرایط پرداخت قسطی',
    path: '/car-insurance/info',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/complate-profile')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'تکمیل مشخصات',
    path: '/third-party/profile',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/complate-profile/profile')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'تکمیل مشخصات',
    path: '/car-insurance/profile',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/complate-profile/profile')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'تکمیل مشخصات',
    path: '/building/profile',
    exact: true,
    icon: '',
    component: () =>
      lazy(() => import('pages/building-complate-profile/profile')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'تکمیل مشخصات',
    path: '/cure/profile',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/cure-complate-profile/profile')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'تکمیل مشخصات',
    path: '/doctor/profile',
    exact: true,
    icon: '',
    component: () =>
      lazy(() => import('pages/doctor-complate-profile/profile')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'تکمیل مشخصات',
    path: '/trip/profile',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/trip-complate-profile/profile')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'نمایش اطلاعات و مشخصات',
    path: '/third-party/confirm',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/confirm-payment')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'آدرس ارسال بیمه نامه',
    path: '/building/address',
    exact: true,
    icon: '',
    component: () =>
      lazy(() => import('pages/building-complate-profile/address')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'آدرس ارسال بیمه نامه',
    path: '/trip/address',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/trip-complate-profile/address')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'آدرس ارسال بیمه نامه',
    path: '/cure/address',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/cure-complate-profile/address')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'آدرس ارسال بیمه نامه',
    path: '/doctor/address',
    exact: true,
    icon: '',
    component: () =>
      lazy(() => import('pages/doctor-complate-profile/address')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'آدرس ارسال بیمه نامه',
    path: '/third-party/address',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/confirm-payment/address')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'آدرس ارسال بیمه نامه',
    path: '/car-insurance/address',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/confirm-payment/address')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'تایید و ارسال',
    path: '/third-party/payment',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/confirm-payment/payment')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'تایید و ارسال',
    path: '/car-insurance/payment',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/confirm-payment/payment')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'تایید و ارسال',
    path: '/building/payment',
    exact: true,
    icon: '',
    component: () =>
      lazy(() => import('pages/building-complate-profile/payment')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'تایید و ارسال',
    path: '/cure/payment',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/cure-complate-profile/payment')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'تایید و ارسال',
    path: '/doctor/payment',
    exact: true,
    icon: '',
    component: () =>
      lazy(() => import('pages/doctor-complate-profile/payment')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'تایید و ارسال',
    path: '/trip/payment',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/trip-complate-profile/payment')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'پروفایل کاربری',
    path: '/profile',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/profile/')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'تراکنش ها ',
    path: '/profile/transactions',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/profile/transactions')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'لیست بیمه نامه ها ',
    path: '/profile/insuranceList',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/profile/insurance')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'یادآور ها ',
    path: '/profile/reminder',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/profile/reminder')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'ویرایش پروفایل',
    path: '/profile/editProfile',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/profile/editProfile')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'نتیجه پرداخت',
    path: '/result',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/result-bank')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'فاکتور',
    path: '/profile/bill/:id',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/bill')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'آیکون ها',
    path: '/icons',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/iconList')),
    include: [''],
    appBar: true,
    guard: SHOULD_AUTH,
  },
  {
    title: 'ورود کاربران وزارت نفت',
    path: '/landing/naft',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/landing/naft')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'خرید بیمه شخص ثالث خودرو',
    path: '/insurances/thirdParty',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/insuranceTypes/thirdParty')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'خرید بیمه موتور',
    path: '/insurances/motor',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/insuranceTypes/motor')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  {
    title: 'خرید بیمه بدنه',
    path: '/insurances/body',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/insuranceTypes/body')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  // {
  //   title: 'خرید بیمه آتش سوزی',
  //   path: '/insurances/fire',
  //   exact: true,
  //   icon: '',
  //   component: () => lazy(() => import('pages/insuranceTypes/fire')),
  //   include: [''],
  //   appBar: true,
  //   guard: NO_DIFFERENT,
  // },
  // {
  //   title: 'خرید بیمه زلزله',
  //   path: '/insurances/earthquake',
  //   exact: true,
  //   icon: '',
  //   component: () => lazy(() => import('pages/insuranceTypes/earthquake')),
  //   include: [''],
  //   appBar: true,
  //   guard: NO_DIFFERENT,
  // },
  // {
  //   title: 'خرید بیمه مسافرتی',
  //   path: '/insurances/trip',
  //   exact: true,
  //   icon: '',
  //   component: () => lazy(() => import('pages/insuranceTypes/trip')),
  //   include: [''],
  //   appBar: true,
  //   guard: NO_DIFFERENT,
  // },
  // {
  //   title: 'خرید بیمه مسئولیت پزشکان ',
  //   path: '/insurances/doctor',
  //   exact: true,
  //   icon: '',
  //   component: () => lazy(() => import('pages/insuranceTypes/doctor')),
  //   include: [''],
  //   appBar: true,
  //   guard: NO_DIFFERENT,
  // },
  {
    title: 'بیمه عمر',
    path: '/insurances/life',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/insuranceTypes/life')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  // {
  //   title: 'بیمه درمان',
  //   path: '/insurances/cure',
  //   exact: true,
  //   icon: '',
  //   component: () => lazy(() => import('pages/insuranceTypes/cure')),
  //   include: [''],
  //   appBar: true,
  //   guard: NO_DIFFERENT,
  // },
  {
    title: 'بیمه سازمانی',
    path: '/insurances/organizational',
    exact: true,
    icon: '',
    component: () => lazy(() => import('pages/insuranceTypes/organizational')),
    include: [''],
    appBar: true,
    guard: NO_DIFFERENT,
  },
  // {
  //   title: '404',
  //   path: '*',
  //   exact: true,
  //   icon: '',
  //   component: () => lazy(() => import('pages/404')),
  //   include: [''],
  //   appBar: true,
  //   guard: NO_DIFFERENT
  // }
];

export default routes;

export const visibleRoute = (which) => {
  return routes
    .filter((route) => route.include.indexOf(which) !== -1)
    .reduce((a, b) => {
      return {
        ...a,
        [b.path]: b,
      };
    }, {});
};
